/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import ITipoSociedad from './entidades/tipoSociedad';

export default class ModeloTipoSociedad {
    public consultarTipoSociedad() {
        return manejadorRest<IRespuesta<ITipoSociedad>>(() =>
            seguridad.get('TipoSociedad/ConsultarListaTipoSociedad')
        );
    }
    public crearTipoSociedad(tipoSociedad: ITipoSociedad) {
        return manejadorRest<IRespuesta<ITipoSociedad>>(() =>
            seguridad.post('TipoSociedad/GuardarTipoSociedad', tipoSociedad)
        );
    }
    public editarTipoSociedad(tipoSociedad: ITipoSociedad) {
        return manejadorRest<IRespuesta<ITipoSociedad>>(() =>
            seguridad.put('TipoSociedad/EditarTipoSociedad', tipoSociedad)
        );
    }
    public eliminarTipoSociedad(tipoSociedad: ITipoSociedad) {
        return manejadorRest<IRespuesta<ITipoSociedad>>(() =>
            seguridad.delete('TipoSociedad/EliminarTipoSociedad', tipoSociedad)
        );
    }
}
